import {
  ApplicationRef,
  ViewContainerRef,
  ComponentRef,
  Injector,
  Injectable,
  ReflectiveInjector
} from '@angular/core';

import { createComponent } from '../framework/createComponent';
import { DialogRef } from '../models/dialog-ref';
import { OverlayRenderer } from '../models/tokens';
import { ModalOverlay } from '../overlay/index';
export class DOMOverlayRenderer implements OverlayRenderer {
private isDoc: boolean = !(typeof document === 'undefined' || !document);
/**
 * @param {?} appRef
 * @param {?} injector
 */
constructor(private appRef: ApplicationRef,
private injector: Injector) { }
/**
 * @param {?} dialog
 * @param {?} vcRef
 * @param {?=} injector
 * @return {?}
 */
render(dialog: DialogRef<any>, vcRef: ViewContainerRef, injector?: Injector): ComponentRef<ModalOverlay> {
    if (!injector) {
      injector = this.injector;
    }

    const /** @type {?} */ bindings = ReflectiveInjector.resolve([
      { provide: DialogRef, useValue: dialog }
    ]);

    const /** @type {?} */ cmpRef = createComponent({
      component: ModalOverlay,
      vcRef,
      injector,
      bindings
    });

    if (!vcRef) {
      this.appRef.attachView(cmpRef.hostView);

      // TODO: doesn't look like this is needed, explore. leaving now to be on the safe side.
      dialog.onDestroy.subscribe( () => this.appRef.detachView(cmpRef.hostView) );
    }

    if (vcRef && dialog.inElement) {
      vcRef.element.nativeElement.appendChild(cmpRef.location.nativeElement);
    } else if (this.isDoc) {
      document.body.appendChild(cmpRef.location.nativeElement);
    }

    return cmpRef;
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ApplicationRef, },
{type: Injector, },
];
}

function DOMOverlayRenderer_tsickle_Closure_declarations() {
/** @type {?} */
DOMOverlayRenderer.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DOMOverlayRenderer.ctorParameters;
/** @type {?} */
DOMOverlayRenderer.prototype.isDoc;
/** @type {?} */
DOMOverlayRenderer.prototype.appRef;
/** @type {?} */
DOMOverlayRenderer.prototype.injector;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
